module.exports = __webpack_public_path__ + "img/paypal-bg.16d96ce9.svg";